import * as React from "react";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {Invoke}         from "@Common/react/invoke";
import {UseState}       from "@Common/react/use-state";
import {ItemOptions}    from "@Common/ui-components/heavy/item-options/item-options";
import {chain}          from "@Common/utils/fs";

import {loadCustomizeRoute}      from "../../load-customize-route";
import {loadMailingLists}        from "../common/load-mailing-lists";
import {populateDefaultItemData} from "../common/populate-default-item-data";

export const PreloadStep = ({match}) => cs(
    ({}, next) => loadCustomizeRoute({next}),
    ({}, next) => loadMailingLists({next}),
    consumeContext("apis"),
    consumeContext("templateOptionsCache"),
    consumeContext("routerHistory"),
    ["state", (_, next) => UseState({
        next,
    })],

    ["templateIds", (_, next) => next({
        front: match.params.front_template_id,
        back : match.params.back_template_id,
    })],
    ["templateOptions", ({templateOptionsCache, templateIds}, next) => templateOptionsCache.load({
        key: templateIds,
        next,
    })],

    ({templateOptions}, next) => templateOptions.loading ? (
        "Loading Template options..."
    ) : (
        next()
    ),

    ["itemOptions", ({templateOptions}, next) => ItemOptions({
        templateOptions: templateOptions.value,
        item: null,
        next,
    })],
    ({state, itemOptions, apis, templateOptions, routerHistory}) => (
        <div className="">

            {Invoke({
                action: async () => {

                    state.onChange({initializingItem: true});


                    const {newValue, /* onSaved */} = chain(
                        populateDefaultItemData({}, {
                            templateOptions: templateOptions.value,
                            listingUniqueId: sessionStorage.getItem("listingUniqueId"),
                        }),
                        (item) => itemOptions.itemEditor.prepareSave(item),
                    );

                    const item = await apis.next.item.createItem(newValue);
                    if (item) {
                        if ( item.orderType === 'PickPack' ) {
                            routerHistory.push(`/options/${item.itemId}`);
                        } else {
                            routerHistory.push(`/customize/order/${item.itemId}`);
                        }
                    } else {
                        state.onChange({error: true});
                    }
                },
            })}

            {state.value == null ? (
                <div className="">
                    Preloading...
                </div>
            ) : state.value.initializingItem ? (
                <div className="">
                    Initializing your order, please wait a few seconds...
                </div>
            ) : (
                <div className="">
                    Failed to initialize order
                </div>
            )}

        </div>
    ),
);

